import { useEffect, useState } from 'react';

export const useFitoListGenerateQuery = ({
  defaultQuery,
  queryResults,
  appliedFilters,
  paginationQuery,
  tabs,
  selectedTabIndex,
  setIsWaitingForRearrangeToEnd,
  forceRefresh,
  enableForceRefresh,
  unsetForceRefresh,
}: {
  defaultQuery: { [name: string]: any };
  queryResults: (query: { [name: string]: any }, props?: any) => any;
  appliedFilters?: { [key: string]: any | undefined };
  paginationQuery: { [name: string]: any };
  tabs?: { [name: string]: any }[];
  selectedTabIndex: number;
  setIsWaitingForRearrangeToEnd: (value: boolean) => void;
  forceRefresh: boolean;
  enableForceRefresh: () => void;
  unsetForceRefresh: () => void;
}) => {
  const [query, setQuery] = useState<{ [name: string]: any }>(defaultQuery);
  const { responseHeaders, data, isLoading, error } = queryResults(query);

  useEffect(() => {
    if (forceRefresh || appliedFilters) {
      let newQuery = { ...defaultQuery, ...appliedFilters, ...paginationQuery };
      if (tabs) {
        newQuery = { ...newQuery, ...tabs[selectedTabIndex].query };
      }
      setQuery(newQuery);
      unsetForceRefresh();
      setIsWaitingForRearrangeToEnd(false);
    }
  }, [forceRefresh, selectedTabIndex, appliedFilters, defaultQuery, paginationQuery]);

  return {
    query,
    data,
    isLoading,
    error,
    forceRefresh,
    enableForceRefresh,
    responseHeaders,
  };
};
